export default {
	state:{
		policy:{},
		policyId:'',
		scheme:1,
	},
	mutations:{
		setHaierPolicy (state,policy) {
			state.policy = policy;
		},
		setHaierPolicyId (state,id) {
			state.policyId = id;
		},
		setHaierScheme (state,scheme) {
			state.scheme = scheme;
		}
	},
}


// WEBPACK FOOTER //
// ./src/store/haier.js